<ng-container *transloco="let t">
  <form [formGroup]="form" (ngSubmit)="login()">
    <div class="login-logo">
      <img src="logo-small.svg" alt="" />
      FMS
    </div>
    <div class="login-box mat-elevation-z3 w-[320px] mx-auto p-4 rounded">
      <h2 class="text-2xl my-5 font-bold">{{ t('loginPage.title') }}</h2>
      <div class="container">
        <mat-form-field>
          <mat-label>{{ t('loginPage.form.email') }}</mat-label>
          <input type="text" matInput name="email" formControlName="email" />
          <mat-icon matIconSuffix>person</mat-icon>
          <mat-error>{{ f.email.errors | validationError }}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ t('loginPage.form.password') }}</mat-label>
          <input [type]="hidePassword() ? 'password' : 'text'" matInput name="password" formControlName="password" />
          <button
            type="button"
            tabindex="-1"
            matIconButton
            matSuffix
            (click)="hidePassword.set(!hidePassword())"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hidePassword()"
            style="margin-right: 4px"
          >
            <mat-icon>{{ hidePassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error>{{ f.password.errors | validationError }}</mat-error>
        </mat-form-field>

        <button type="submit" class="login-btn" matButton="filled" [disabled]="isLoading()">
          <app-loading-container [loading]="isLoading()" [size]="30">{{
            t('loginPage.button.submit')
          }}</app-loading-container>
        </button>

        <div class="mt-12 flex justify-center gap-2">
          <button matButton="outlined" type="button" (click)="changeLang('en')">EN</button>
          <button matButton="outlined" type="button" (click)="changeLang('pl')">PL</button>
        </div>
      </div>
    </div>
  </form>
  <mat-icon>user</mat-icon>
</ng-container>
